import React from 'react'
import { TagProps } from './Tag.types'
import { StyledTag, TagIcon } from './Tag.styles'

export const Tag: React.FC<TagProps> = ({
  children,
  variant = 'gray',
  icon,
  size = 'medium',
  onClick,
  className,
}) => {
  return (
    <StyledTag
      $variant={variant}
      $size={size}
      $clickable={!!onClick}
      onClick={onClick}
      className={className}
    >
      {icon && <TagIcon>{icon}</TagIcon>}
      {children}
    </StyledTag>
  )
}
